import './style.scss';

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('form.rte-contact-form').forEach((form) => {
		const responseEl = form.nextElementSibling;
		const errorEl = form.querySelector('.contact-error');

		form.addEventListener('submit', async (e) => {
			e.preventDefault();
			errorEl.style.display = 'none';
			responseEl.style.display = 'none';
			const data = Object.fromEntries(new FormData(form).entries());
			const submitButton = form.querySelector('button[type="submit"]');

			if (submitButton) {
				submitButton.disabled = true;
				submitButton.textContent = 'Submitting...';
			}

			try {
				const res = await fetch(ContactFormData.url, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify(data),
				});

				const result = await res.json();
				if (res.ok) {
					responseEl.querySelector('p').textContent = result.message;
					form.reset();

					const formHeight = form.offsetHeight;
					form.style.height = formHeight + 'px';
					form.style.overflow = 'hidden';
					form.style.opacity = '0';
					form.style.transition = 'opacity 0.3s ease';

					setTimeout(() => {
						form.style.display = 'none';
						form.style.height = '';
						form.style.overflow = '';
						form.style.opacity = '';
						responseEl.style.display = 'block';
						errorEl.style.display = 'none';

						responseEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
					}, 300);
				} else {
					errorEl.textContent = result.message;
					errorEl.style.display = 'block';

					submitButton.disabled = false;
					submitButton.textContent = 'Submit';
				}
			} catch (err) {
				errorEl.textContent = 'Unable to submit the form. Please try again.';
				errorEl.style.display = 'block';

				submitButton.disabled = false;
				submitButton.textContent = 'Submit';
			}
		});
	});
});
